module.exports = __webpack_public_path__ + "media/images/instagram-1-4303bcd4928d9acfae125b5c5bf55e5e.png";